import React, { useState, FC } from "react";
import "./step.css";
interface Step {
  status: string;
  [key: string]: any;
}

interface StepProgressProps {
  onClick?: (step: Step, index: number) => void;
  steps?: Step[];
}



const Stepper: FC<StepProgressProps> = ({
  onClick = () => { },
  steps = [],
}) => {
  const [activeStep, setActiveStep] = useState<number>(0);

  const handleStepClick = (step: Step, index: number) => {
    setActiveStep(index);
    onClick(step, index);
  };

  return (
    <div className="step-progress">
      {steps.map((step, index) => {
        const isActive = index === activeStep;
        const isLast = index === steps.length - 1;

        return (
          <div
            key={index}
            style={{ cursor: "pointer" }}
            className={`step ${isActive ? "active" : ""} ${!isLast ? "with-arrow" : ""
              }`}
            onClick={() => handleStepClick(step, index)}
          >
            {step.status}
          </div>
        );
      })}
    </div>
  );
};

export default React.memo(Stepper);
